<template>
  <div class="fly-item">
    <div class="icon-img">
      <van-image class="img" round :src="item.avatar"></van-image>
      <div class="name" v-show="item.nickname">{{ item.nickname }}</div>
    </div>
    <div class="mid">
      <div class="p1">实飞面积 {{ item.work_mu }} 亩</div>
      <div class="p2">
        无人机共<span class="number">{{ item.plane_count }}</span
        >台
      </div>
      <div class="p3" v-if="item.start_time !== ''">
        {{ item.start_time }}—{{ item.end_time ? item.end_time : "至今" }}
      </div>
    </div>
    <van-icon name="arrow" class="icon" size="15" />
  </div>
</template>
<script>
export default {
  name: "all_fly-item",
  components: {},
  props: {
    flyData: {
      type: Object,
      default: function() {
        return {};
      }
    }
  },
  data() {
    return {};
  },
  computed: {
    item() {
      return this.flyData;
    }
  },
  watch: {},
  mounted() {
    // this.item = this.flyData;
  },
  destroyed() {},
  methods: {}
};
</script>
<style lang="stylus" scoped>
.fly-item
  background #fff
  height 100%
  display flex
  align-items center
  padding 15px 0
  .icon-img
    width 66px
    text-align center
    .img
      width 40px
      height 40px
      margin 0 auto
    .name
      font-size 15px
      color #282828
      margin-top 5px
  .mid
    flex 1
    min-width 0
    display flex
    flex-direction column
    justify-content space-between
    text-align left
    .p1
      font-size 15px
      color #282828
      margin-bottom 5px
    .p2
      font-size 14px
      color #666666
      margin-bottom 5px
      .number
        color #282828
        margin 0 2px
    .p3
      font-size 12px
      color #666666
    .grey
      color #999999
  .icon
    margin 0 12px
    font-weight bold
    color #BEBEBE
    margin-top: -3px;
    vertical-align: middle;
    font-size 15px
</style>
